import axios from '@/axiosInstance.ts'
import {AuthUser} from '@/features/auth/types'
import {z} from 'zod'

/**
 * This function is used to validate the code received during the sso process
 */
/**
 * Login function
 */
export interface HttpLoginPayload {
    email: string
    password: string
}

export const HttpLoginResponse = z.object({
    user: AuthUser,
    accessToken: z.string(),
    refreshToken: z.string()
})
export type HttpLoginResponse = z.infer<typeof HttpLoginResponse>

export const httpLogin = (payload: HttpLoginPayload) => {
    return axios.post('/auth/login', payload)
}

/**
 * Logout function
 */
export const httpLogout = () => {
    return axios.post('/auth/logout')
}

/**
 * This function Retrieves user data
 */
export const httpUserMe = () => {
    return axios.get(`/users/me`, {
        params: {
            responseType: 'small'
        }
    })
}

/**
 *  Request to change the password by sending an invite link via email
 */
export const HttpPasswordRecovery = z.object({
    email: z
        .string()
        .email()
        .transform(val => val.toLowerCase().trim())
})
export type HttpPasswordRecovery = z.infer<typeof HttpPasswordRecovery>
export const httpPasswordRecovery = (payload: HttpPasswordRecovery) => {
    return axios.post('/password-recovery/send-email', payload)
}

/**
 * Verify token function from the email link by recovery service
 */
export const HttpVerifyRecoveryTokenPayload = z.object({
    token: z.string()
})
export type HttpVerifyRecoveryTokenPayload = z.infer<typeof HttpVerifyRecoveryTokenPayload>

export const httpVerifyRecoveryToken = (data: HttpVerifyRecoveryTokenPayload) => {
    return axios.post('/password-recovery/verify-token', data)
}

/**
 * Reset password via new password and recovery token by recovery service
 */
export const HttpResetPasswordPayload = z.object({
    password: z.string(),
    passwordConfirmation: z.string(),
    token: z.string()
})
export type HttpResetPasswordPayload = z.infer<typeof HttpResetPasswordPayload>

export const httpResetPassword = (data: HttpResetPasswordPayload) => {
    return axios.post('/password-recovery/reset', data)
}

/**
 * Verify token function from the email invite link
 */
export const HttpVerifyInviteTokenPayload = z.object({
    token: z.string()
})
export type HttpVerifyInviteTokenPayload = z.infer<typeof HttpVerifyInviteTokenPayload>

export const httpVerifyInviteToken = (data: HttpVerifyInviteTokenPayload) => {
    return axios.post('/auth/verify-token', data)
}

/**
 * Set user password by invite
 */
export const HttpSetPasswordPayload = z.object({
    password: z.string(),
    passwordConfirmation: z.string(),
    token: z.string()
})
export type HttpSetPasswordPayload = z.infer<typeof HttpSetPasswordPayload>

export const httpSetPassword = (data: HttpSetPasswordPayload) => {
    return axios.post('/auth/set-password', data)
}
